import { IGioHocRangBuocActionTypes } from "../../action-types/category/IGioHocRangBuocActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IGioHocRangBuocReducer } from "../../reducer-model/category/IGioHocRangBuocReducer";

const initState: IGioHocRangBuocReducer = {
  status: eReducerStatusBase.is_not_initialization,
  gioHocRangBuocs: [],
};
export const gioHocRangBuocReducer = (
  state: IGioHocRangBuocReducer = initState,
  action: IGioHocRangBuocActionTypes
): IGioHocRangBuocReducer => {
  switch (action.type) {
    case "GIO_HOC_RANG_BUOC_LOAD_START":
      return { ...state, status: eReducerStatusBase.is_loading };
    case "GIO_HOC_RANG_BUOC_LOAD_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_completed, gioHocRangBuocs: action.payload };
    case "GIO_HOC_RANG_BUOC_LOAD_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "GIO_HOC_RANG_BUOC_SHOW_EDIT_MODAL":
      return { ...state, isShowEditModal: true, gioHocRangBuocEditing: action.payload };
    case "GIO_HOC_RANG_BUOC_CLOSE_EDIT_MODAL":
      return { ...state, isShowEditModal: false };
    case "GIO_HOC_RANG_BUOC_SAVE_START":
      return { ...state, status: eReducerStatusBase.is_saving };
    case "GIO_HOC_RANG_BUOC_SAVE_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_need_reload, isShowEditModal: false };
    case "GIO_HOC_RANG_BUOC_SAVE_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "GIO_HOC_RANG_BUOC_DELETE_START":
      return { ...state, status: eReducerStatusBase.is_deleting };
    case "GIO_HOC_RANG_BUOC_DELETE_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_need_reload };
    case "GIO_HOC_RANG_BUOC_DELETE_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    default:
      return state;
  }
};
